import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  standalone: true,
  selector: "app-prefix-pr3",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-pr3.component.html",
  styleUrl: "./prefix-pr3.component.less",
})
export class PrefixPr3Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 3;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["pr3"];
  }
}
